var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"workstation-form-page"}},[_c('workstation-form',{attrs:{"form-type":'edit'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }